// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Spinner = require("./Spinner.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");

function InputWithPrefix$LoadingSpinner(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Spinner.make, {}),
    className: "h-21 w-21 flex items-center justify-center"
  });
}

function InputWithPrefix(props) {
  let status = props.status;
  let borderColor = status !== undefined ? (
      status === "error" ? "border-tan-error-500" : (
          status === "ok" ? "border-tan-success" : "border-zinc-200"
        )
    ) : "border-zinc-200";
  let inputRef = React.useRef(null);
  let onClick = React.useCallback(param => Stdlib_Option.forEach(Primitive_option.fromNullable(inputRef.current), el => el.focus()), []);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.prefix,
        className: "text-zinc-500 cursor-default"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("input", {
            ref: Primitive_option.some(i => {
              inputRef.current = i;
            }),
            className: "text-zinc-800 flex-grow min-w-0",
            spellCheck: false,
            value: props.value,
            onBlur: props.onBlur,
            onChange: props.onChange
          }),
          status === "validating" ? JsxRuntime.jsx(InputWithPrefix$LoadingSpinner, {}) : null
        ],
        className: "flex items-center min-w-0 gap-1 flex-grow"
      })
    ],
    className: TailwindMerge.twMerge([
      borderColor,
      "flex flex-col lg:flex-row border rounded-md px-3 py-2 gap-x-1 gap-y-2 [&:has(input:focus)]:border-zinc-300"
    ]),
    onClick: onClick
  });
}

let make = InputWithPrefix;

exports.make = make;
/* react Not a pure module */
